import { render, staticRenderFns } from "./label-list.vue?vue&type=template&id=1712a489&lang=pug"
import script from "./label-list.vue?vue&type=script&lang=js"
export * from "./label-list.vue?vue&type=script&lang=js"
import style0 from "./label-list.vue?vue&type=style&index=0&id=1712a489&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports